import { HelmetDexteel } from "@dexteel/mesf-core";
import Grid2 from "@mui/material/Grid2";
import { masterDetailsMinHeight, pageBgColor } from "@/utils/theme";
import { useQuery } from "@tanstack/react-query";
import { TableParts } from "./components/TableParts";
import { getParts } from "./repositories/PartsReportRepository";
import { PartsResult } from "./models/Part";

type usePartsProps = {
	partId?: number;
	onError?: (error: Error) => void;
};

export const useParts = ({ partId, onError }: usePartsProps) => {
	return useQuery<PartsResult, Error>({
		queryKey: ["parts", partId],
		queryFn: ({ signal }) => getParts({ partId }, signal),
		onError: onError,
	});
};

export const PartsManagerPage = () => {
	return (
		<>
			<HelmetDexteel title="Parts Manager" />
			<Grid2
				container
				justifyContent="center"
				alignItems="flex-start"
				sx={{ backgroundColor: pageBgColor, minHeight: masterDetailsMinHeight }}
			>
				<Grid2 size={{ xs: 12, md: 8 }} style={{ margin: 0 }}>
					<TableParts />
				</Grid2>
			</Grid2>
		</>
	);
};
